import { Typography } from '@material-tailwind/react'
import { OfficeSelector as AsyncOfficeSelector } from '@/shared/selectors/office-selector/office-selector'

export const OwnOfficeSelector = ({ offices, officeId, setOfficeId, instructions = true }) => {
  if (!offices || offices.length === 0) return null

  const onlyOne = offices.length === 1

  if (onlyOne) {
    return (
      <header className="flex flex-col px-4 py-3 bg-white">
        <Typography variant="small" className="font-medium">
          Dependencia: {offices[0].name}
        </Typography>
      </header>
    )
  }

  const selectedValue = officeId === 'all' || !officeId ? null : officeId

  return (
    <header className="flex flex-col px-4 py-3 bg-white">
      <AsyncOfficeSelector
        value={selectedValue}
        isClearable
        onChange={(option) => setOfficeId(option ? String(option.value) : 'all')}
        placeholder="Todas las dependencias"
        label="Dependencia"
        className="max-w-2xl"
      />
      {(!officeId || officeId === 'all') && (instructions) && (
        <Typography variant="small" color="red" className="mt-1">
          Selecciona una dependencia para registrar entrada o salida.
        </Typography>
      )}
    </header>
  )
}